import { createPersistedStore } from "./createPersistedStore";

type SettingsState = {
  defaultStore?: string;
};

type SettingsAction = {
  setDefaultStore: (store?: string) => void;
  reset: () => void;
};

const defaultState: SettingsState = {
  defaultStore: undefined,
};

export const useSettingsStore = createPersistedStore<SettingsState, SettingsAction>(
  defaultState,
  (set) => ({
    setDefaultStore(store) {
      set((state: any) => {
        state.defaultStore = store;
      });
    },
    reset() {
      set(() => defaultState);
    },
  }),
  "settings",
  (state) => ({
    defaultStore: state.defaultStore,
  })
);